import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "innermodaloverflow" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold-16" }, "Summary ", -1)
const _hoisted_3 = { class: "font-regular-16 btm-1" }
const _hoisted_4 = {
  class: "userlistdiv",
  "data-cy": "users-summary-list"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "font-regular-16 breaking-words" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addonsList, (addon, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "addonlistdiv"
      }, [
        _createElementVNode("label", _hoisted_3, [
          _createTextVNode(" Add-on \""),
          _createElementVNode("strong", null, _toDisplayString(addon.productName), 1),
          _createTextVNode("\" will be assigned to users ")
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (
              item.addOns?.length === 0 ||
              !item.addOns?.some(
                (a) => a.productBucketId === addon.productBucketId
              ))
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _createElementVNode("label", _hoisted_6, [
                      (item.firstName && item.lastName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.firstName) + ", " + _toDisplayString(item.lastName) + ", ", 1))
                        : (item.userName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.userName) + ", ", 1))
                          : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(item.email), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}